const prefix = 'bravissimo/socket/';
export const SUBSCRIBE = `${prefix}SUBSCRIBE`;
export const UNSUBSCRIBE = `${prefix}UNSUBSCRIBE`;
export const CONNECT = `${prefix}CONNECT`;
export const DISCONNECT = `${prefix}DISCONNECT`;
export const EMIT = `${prefix}EMIT`;
export const FAILURE = `${prefix}FAILURE`;
export const SUCCESS = `${prefix}SUCCESS`;
